import {
  buildBankingApiFetchOptionsWithHeaders,
  convertObjectToQueryString,
  standardizedFetchHandler,
} from 'externals/_services/service_helpers';
import {
  buildBankingConfig,
  buildOptInSecuredCardV2,
  buildProfileUIState,
  buildPurseWithdraw,
  buildSecuredCardEndpoint,
  buildSecuredCardPayment,
  buildSecuredCardSettings,
  buildSecuredCardTransactions,
  buildStackSecuredCardStatements,
} from 'api-urls';

export const deleteBuilderAccount = async token => {
  const fetchOpts = buildBankingApiFetchOptionsWithHeaders(token, {
    method: 'DELETE',
  });
  return standardizedFetchHandler(buildSecuredCardEndpoint(), fetchOpts);
};

export const fetchBuilderStatements = async (token, numberOfStatements) => {
  const fetchOpts = buildBankingApiFetchOptionsWithHeaders(token);
  const query = convertObjectToQueryString({
    numberOfStatements,
    includeUpcoming: true,
  });
  return standardizedFetchHandler(
    buildStackSecuredCardStatements() + query,
    fetchOpts,
  );
};

export const fetchSecuredCardSettings = async token => {
  const fetchOpts = buildBankingApiFetchOptionsWithHeaders(token);

  return standardizedFetchHandler(buildSecuredCardSettings(), fetchOpts);
};

export const fetchBuilderRecentTransaction = async (token, numTransactions) => {
  const fetchOpts = buildBankingApiFetchOptionsWithHeaders(token);

  const query = convertObjectToQueryString({ numTransactions });
  return standardizedFetchHandler(
    buildSecuredCardTransactions() + query,
    fetchOpts,
  );
};

export const postPurseWithdraw = async (token, amount) => {
  const fetchOpts = buildBankingApiFetchOptionsWithHeaders(token, {
    method: 'POST',
    body: {
      amount,
    },
  });

  return standardizedFetchHandler(buildPurseWithdraw(), fetchOpts);
};

export const patchSecuredCardSettings = async (token, body) => {
  const fetchOpts = buildBankingApiFetchOptionsWithHeaders(token, {
    method: 'PATCH',
    body,
  });

  return standardizedFetchHandler(buildSecuredCardSettings(), fetchOpts);
};

export const patchUIState = async (token, body) => {
  const fetchOpts = buildBankingApiFetchOptionsWithHeaders(token, {
    method: 'PATCH',
    body,
  });

  return standardizedFetchHandler(buildProfileUIState(), fetchOpts);
};

export async function fetchBankingConfig(cashToken) {
  const fetchOpts = buildBankingApiFetchOptionsWithHeaders(cashToken, false, {
    'Cache-Control': 'no-cache',
  });

  return standardizedFetchHandler(buildBankingConfig(), fetchOpts);
}

export async function postSecuredCardPayment(token, body) {
  const fetchOpts = buildBankingApiFetchOptionsWithHeaders(token, {
    method: 'POST',
    body,
  });

  return standardizedFetchHandler(buildSecuredCardPayment(), fetchOpts);
}

export async function securedCardV2OptIn(token) {
  const fetchOpts = buildBankingApiFetchOptionsWithHeaders(token, {
    method: 'POST',
    body: {},
  });

  return standardizedFetchHandler(buildOptInSecuredCardV2(), fetchOpts);
}
